module.exports = __webpack_public_path__ + "static/s-5-a1ca652f35dff7d9b019eb97b2da66e9.svg";